export const LEGAL_ENTITY_TYPES = [
  { value: 'legalEntity', text: 'Юр.лицо' },
  { value: 'soleProprietor', text: 'ИП' },
  { value: 'privatePerson', text: 'Частное лицо' },
]
